import React from 'react';
import './AssistanceInfo.scss';
import Link from '../../Link/Link';

const AssistanceInfo = ({ phone, phone2, primaryColor }) => {
  return (
    <>
      <div className="assistance">
        <Link to="/pagine/contattaci">
          <span>Assistenza clienti</span>
        </Link>
        {!!phone && (
          <a href={'tel:' + phone} style={{ color: primaryColor }}>
            {phone}
          </a>
        )}
      </div>
      {!!phone2 && (
        <div className="assistance">
          <a href={`https://wa.me/${phone2}`} style={{ color: primaryColor }}>
            WhatsApp {phone2}
          </a>
        </div>
      )}
    </>
  );
};
export default AssistanceInfo;
